import application_settings from '../applicationSettings';
import LocalStorage from '../local_data';
import Event from './Event';

class GetValidateCart extends Event {
    eventName = 'oms_getValidateCart';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get Validate Cart
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        let currentLocation = new LocalStorage.CurrentLocation(clientId).getData();
        let cartLocation = new LocalStorage.CartLocation(currentLocation);
        let selectedProducts = cartLocation.getData();
        let products = [];

        if (selectedProducts && Object.keys(selectedProducts).length > 0) {
            products = Object.keys(selectedProducts).map( id => { 
                return {"id": id, "quantity": selectedProducts[id].item_qty}; 
            });
        }

        // request data
        data.endPoint = application_settings.endPoints.validateCart;
        data.multi_call_key = (data.multi_call_key) ? data.multi_call_key : 'validate_cart';
        data.method = 'POST';
        data.data = {
            client_id: clientId,
            location_id: currentLocation,
            order_currency:data.order_currency,
            products: JSON.stringify(products)
        };
        
        // send request
        this.sendRequest(data, function (response) {
            if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });

                if (data.data) {
                    let cartLocation = new LocalStorage.CartLocation(currentLocation);
                    let selectedProducts = cartLocation.getData();

                    data.data.forEach(function (item) {
                        if (selectedProducts[item.id]) {
                            selectedProducts[item.id].item_weight = (item.attributes.hasOwnProperty('weight')) ? item.attributes.weight : '';
                            selectedProducts[item.id].item_msrp_price = (item.attributes.hasOwnProperty('msrp')) ? item.attributes.msrp : '';
                            selectedProducts[item.id].item_preparation_time = (item.attributes.hasOwnProperty('preparation_time')) ? item.attributes.preparation_time : '';
                            selectedProducts[item.id].item_initial_price = Number(item.unit_price);
                            selectedProducts[item.id].item_price = Number(item.unit_price);
                            selectedProducts[item.id].item_display_price = Number(item.display_price);
                            selectedProducts[item.id].discount_price = Number(item.display_price);
                            selectedProducts[item.id].item_name = (item.parent_name) ? item.parent_name : item.name;
                        }
                    });

                    new LocalStorage.CartLocation(currentLocation).setData(selectedProducts);
                }
            }
        });

    }
}

export default GetValidateCart;